import api from './api'

const BASE = '/timesheets/time-entries'

// Dopo aver approvato o rifiutato ore, il menu aggiorna subito il suo badge
// invece di aspettare il prossimo controllo periodico.
export const HOURS_CHANGED_EVENT = 'hours-changed'
export const notifyHoursChanged = () => window.dispatchEvent(new Event(HOURS_CHANGED_EVENT))

export const timesheetsService = {
  list: (params = {}) => api.get(`${BASE}/`, { params }).then((r) => r.data),
  get: (id) => api.get(`${BASE}/${id}/`).then((r) => r.data),
  create: (data, { overtimeConfirmed = false } = {}) =>
    api
      .post(`${BASE}/`, data, {
        headers: overtimeConfirmed ? { 'X-Overtime-Confirmed': 'true' } : {},
      })
      .then((r) => r.data),
  update: (id, data) => api.patch(`${BASE}/${id}/`, data).then((r) => r.data),
  delete: (id) => api.delete(`${BASE}/${id}/`),
  approve: (id) => api.post(`${BASE}/${id}/approve/`).then((r) => r.data),
  reject: (id) => api.post(`${BASE}/${id}/reject/`).then((r) => r.data),
  pending: () => api.get(`${BASE}/pending/`).then((r) => r.data),
  // ore in attesa dell'approvazione di chi guarda (escluse le sue): badge del menu
  pendingCount: () => api.get(`${BASE}/pending-count/`).then((r) => r.data),
  summary: (projectId) =>
    api.get(`${BASE}/summary/`, { params: { project: projectId } }).then((r) => r.data),
  // Import Vepro "Report Ore.xlsx": senza confirm fa il preview, con confirm applica.
  // resourceMap (solo in conferma): { SIGLA: user_id } per abbinare le sigle risorsa
  // agli utenti; le sigle non mappate creano utenti disattivati "vepro_<sigla>".
  importVepro: (file, { confirm = false, resourceMap = null } = {}) => {
    const fd = new FormData()
    fd.append('file', file)
    if (confirm) fd.append('confirm', 'true')
    if (resourceMap) fd.append('resource_map', JSON.stringify(resourceMap))
    return api
      .post(`${BASE}/import_vepro/`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data)
  },
}

export const externalTimesheetsService = {
  list: (params = {}) =>
    api.get('/timesheets/external-time-entries/', { params }).then((r) => r.data),
  create: (data) =>
    api.post('/timesheets/external-time-entries/', data).then((r) => r.data),
  update: (id, data) =>
    api.patch(`/timesheets/external-time-entries/${id}/`, data).then((r) => r.data),
  delete: (id) =>
    api.delete(`/timesheets/external-time-entries/${id}/`),
  approve: (id) =>
    api.post(`/timesheets/external-time-entries/${id}/approve/`).then((r) => r.data),
  reject: (id) =>
    api.post(`/timesheets/external-time-entries/${id}/reject/`).then((r) => r.data),
}

export const TIMESHEET_STATUSES = [
  { value: 'submitted', label: 'In Attesa', color: 'yellow' },
  { value: 'approved', label: 'Approvato', color: 'green' },
  { value: 'rejected', label: 'Rifiutato', color: 'red' },
]
